import React from 'react';
import "./footer.css";
import logo from "../../assets/logo.png";
import { Link } from "react-router-dom";

const Footer = () => {

    let year = new Date().getFullYear();

    const scrollTop = () => {
        window.scrollTo(0, 0);
    }

    return (
        <footer>
            <div id='firstpartfooter'>
                <div>
                    <img src={logo} alt="" />
                </div>

                <div id='linksfooter'>
                    <h2 style={{color: '#FFF'}}>Quick links</h2>
                    <Link className='linkfooter' to="/" onClick={scrollTop}>Home</Link>
                    <Link className='linkfooter' to="/about" onClick={scrollTop}>About</Link>
                    <Link className='linkfooter' to="/gallery" onClick={scrollTop}>Gallery</Link>
                    <Link className='linkfooter' to="/rooms" onClick={scrollTop}>Rooms</Link>
                </div>

                <div>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d47273.238908718995!2d20.693398258339165!3d42.22347528972003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1353950a12f4301f%3A0xda0e2e9b8d3d5850!2sPrizren!5e0!3m2!1sen!2s!4v1698530534534!5m2!1sen!2s" width="400" height="300" title='map' style={{border: "0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>

            <div id='secondpartfooter'>
                <p><span id='copyrightsign'>©</span> <a style={{textDecoration: "none", color: "white"}} href="https://tarikajvazi.com">Tarik Ajvazi</a>, <span>{year}</span></p>
            </div>
        </footer>
    );
}
 
export default Footer;